import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Carousel, Modal } from "antd";

import { MdOutlineDragIndicator, MdOutlineFileDownload } from "react-icons/md";
import TagsBox from "../../../components/TagsBox/TagsBox";
import "../Feed/feedTab.css";
import "../Feed new/SubComponents/FeedVideo.css";
import { updateCommentsData } from "../../../Utils/SupabaseServices/CommentsDatabase";
import useUpdatePostAdIndex from "../Feed/useUpdatePostIndex";
import useDeletePosts from "../Feed/useDeletePosts";
import ProductBankActionButtons from "./ProductBankActionButtons";
import useUpdateProductTags from "./useUpdateProductTags";
import { StaticCompnents } from "../../../Utils/StaticComponent";
import AddProductModal from "./AddProductModal";
import HoverVideoPlayer from "react-hover-video-player";
import { formatPostDate } from "../../../Utils/StayUpToDate/RenderComponent";
import ProductBankDeleteModal from "./ProductBankDeleteModal";

const ProductBankSearchTable = ({
  username,
  activeKey,
  data,
  user_id,
  filter,
  setLimitError,
  refetchData,
  refetchCount,
  setIsContentLoading,
  subscription_type,
  brokenLinksContent,
  currentPage,
  linkFilterRefetch,
  setSelectedProductLnikFilter,
  setLocalData
}: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [checkedList, setCheckedList] = useState<any>([]);
  const [selectedPostId, setSelectedPostId] = useState<any>();
  const [tags, setTags] = useState<any>();
  const handleCancel = () => {
    setSelectedPostId("");
    setIsModalOpen(false);
  };
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const { mutate: updateTags } = useUpdateProductTags();
  const { mutate: updatePostAdIndex } = useUpdatePostAdIndex();

  const { mutate: deletePostPermanently } = useDeletePosts();
  const [addProductModalShow, setAddProductModalShow] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  function removeTag(
    tagArr: any,
    tag: any,
    post_id: any,
    pageIndex: number,
    index: number
  ) {
    const idx = tagArr.indexOf(tag);
    tagArr.splice(idx, 1);

    updateTags({
      currentPage,
      activeKey: "Product Bank",
      tagString: tagArr.toString(),
      post_id,
      pageIndex,
      index,
      filter,
      username,
      tag,
      action: "remove",
      user_id,
    });
  }
  function submitTag(
    e: any,
    tagArray: any,
    tag: any,
    post_id: any,
    pageIndex: number,
    index: number
  ) {
    e.preventDefault();
    if (e.keyCode === 13 && tag.trim()) {
      // Format new tag
      const newTag = `|${tag.trim()}|`;

      // Get existing tags as array, filtering out empty strings
      let existingTags = tagArray
        ? tagArray
          .split(",")
          .map((t: any) => t.trim())
          .filter(Boolean)
        : [];

      // Add new tag to existing tags
      existingTags.push(newTag);

      // Remove duplicates and join
      let uniqueItems = Array.from(new Set(existingTags)).join(",");

      updateTags({
        currentPage,
        activeKey: "Product Bank",
        tagString: uniqueItems,
        post_id,
        pageIndex,
        index,
        filter,
        username,
        tag: newTag, // Send just the new tag
        action: "submit",
        user_id,
      });

      e.target.value = "";
    }
  }

  function deletePost(post_id: string, pageIndex: number, index: number) {
    deletePostPermanently({
      postId: post_id,
      activeKey,
      pageIndex,
      postIndex: index,
      filter,
      user_id,
    });
  }

  const handleOk = async () => {
    if (checkedList && checkedList.length) {
      checkedList.map(async (list: any) => {
        setConfirmLoading(true);
        await updateCommentsData(list);
      });
    }
    setSelectedPostId("");
    setIsModalOpen(false);
    setConfirmLoading(false);
  };
  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    const newData = [...data?.pages?.[0]];
    let sourceIndex = result.source.index;
    let post_id = result.draggableId;
    let targetIndex = result.destination.index;

    const [removed] = newData.splice(result.source.index, 1);

    newData.splice(result.destination.index, 0, removed);
    data.pages[0] = [...newData];

    updatePostAdIndex({
      user_id,
      sourceIndex,
      targetIndex,
      activeKey,
      post_id,
      username,
      newData,
    });
  };
  const platformIcons: any = {
    ShopMy: StaticCompnents().ShopMyIcon,
    Amazon: StaticCompnents().AmazonIcon,
    LTK: StaticCompnents().LTKIcon,
    instagram: StaticCompnents().InstagramIcon,
    pinterest: StaticCompnents().PinterestIcon,
    twitter: StaticCompnents().TwitterIcon,
    tiktok: StaticCompnents().TiktokIcon,
    newsletter: StaticCompnents().NewsletterIcon,
    podcast: StaticCompnents().PodcastIcon,
    // Add other platforms here
  };
  const renderPlatformIcon = (platform: any) => {
    const IconComponent = platformIcons[platform];

    if (IconComponent) {
      return <IconComponent />;
    }
    return null; // Return null if platform doesn't exist or is invalid
  };

  const videoRef: any = useRef();
  const [hover, setHover] = useState(false);
  const [customPause, setCustomPause] = useState(false);
  useEffect(() => {
    if (videoRef?.current) {
      videoRef.current.playsInline = true;
    }
  }, []);

  const renderVideoContent = (
    media_url: string,
    thumbnail: string,
    index: number = 0,
    isCarousel: boolean = false
  ) => {
    return (
      <div className={`feed-video-wrapper ${isCarousel ? "mb-2" : ""}`}>
        <HoverVideoPlayer
          videoRef={videoRef}
          videoSrc={media_url}
          className="feed-hover-video"
          muted={true}
          // autoPlay={true}
          preload={"metadata"}
          contextMenu="return false;"
          hoverOverlay={<div className="feed-video-hover"></div>}
          pausedOverlay={
            <div className="feed-video-thumbnail">
              <img
                src={thumbnail || "/assets/dummy_video.png"}
                alt=""
                loading="eager"
              />
            </div>
          }
          loadingOverlay={
            <div className="feed-video-thumbnail">
              <img
                src={thumbnail || "/assets/dummy_video.png"}
                alt=""
                loading="eager"
              />
            </div>
          }
          unloadVideoOnPaused={false}
          onHoverStart={() => {
            setHover(true);
          }}
          onHoverEnd={() => {
            setHover(false);
            setCustomPause(false);
          }}
          disableDefaultEventHandling={customPause}
        />
      </div>
    );
  };
  return (
    <>
      <div className="feed-tab-posts-table">
        {data && data.length > 0 ? (
          <Fragment key={1}>
            {data.map((image: any, index: number) => {
              return (
                <div className="feed-tab-post-row" key={index}>
                  <div className="feed-tab-row-media-bank">
                    <div
                      className="feed-tab-row-media-wrapper"
                      data-platform={image.platform}
                    >
                      {image.platform === "newsletter" ? (
                        <div
                          // style={{
                          //   // Center text inside the div
                          // }}
                          className="no-image-text mb-2"
                        >
                          <span
                            className="newsletter-label"
                            style={{ display: "block" }}
                          >
                            Newsletter
                          </span>
                          <span className="date" style={{ display: "block" }}>

                            {formatPostDate(image.post_date)}
                          </span>
                        </div>
                      ) : image.platform === "linkedin" &&
                        (!image.table_image ||
                          image.table_image.split(",").length === 1) ? (
                        <div className="no-image-text mb-2">
                          <span
                            className="newsletter-label"
                            style={{ display: "block" }}
                          >
                            LinkedIn Post
                          </span>
                          <span className="date" style={{ display: "block" }}>

                            {formatPostDate(image.post_date)}
                          </span>
                        </div>
                      ) : image.platform === "twitter" && !image.table_image ? (
                        <div className="no-image-text mb-2">
                          <span
                            className="newsletter-label"
                            style={{ display: "block" }}
                          >
                            X Post
                          </span>
                          <span className="date" style={{ display: "block" }}>

                            {formatPostDate(image.post_date)}
                          </span>
                        </div>
                      ) : (
                        <>
                          {image.platform === "youtube" &&
                            image.product_image ? (
                            <div className="feed-video-wrapper">
                              <img
                                className="content-tab-media mh-350"
                                src={image.product_image}
                                alt="post"
                              />
                            </div>
                          ) : image.table_image ? (
                            <>
                              {image.table_image.split(",").length > 1 &&
                                image.table_image
                                  .split(",")
                                  .every((url: any) => url.trim() !== "") ? (
                                <div className="feed-carousel-container">
                                  <Carousel
                                    dotPosition="bottom"
                                    className="feed-carousel"
                                  >
                                    {image.table_image
                                      .split(",").slice(0, 10)
                                      .map((media_url: any, index: any) => (
                                        <React.Fragment key={index}>
                                          {media_url.includes("video") ? (
                                            renderVideoContent(
                                              media_url,
                                              image.thumbnail &&
                                                image.thumbnail.split(",")[
                                                index
                                                ]
                                                ? image.thumbnail.split(",")[
                                                index
                                                ]
                                                : "/assets/dummy_video.png",
                                              index,
                                              true
                                            )
                                          ) : (
                                            <div className="feed-carousel-item">
                                              <img
                                                className="feed-carousel-image"
                                                src={media_url}
                                                alt="post"
                                              />
                                            </div>
                                          )}
                                        </React.Fragment>
                                      ))}
                                  </Carousel>
                                </div>
                              ) : (
                                <>
                                  {image.table_image.includes("video") ? (
                                    renderVideoContent(
                                      image.table_image,
                                      image.thumbnail ||
                                      "/assets/dummy_video.png"
                                    )
                                  ) : (
                                    <div className="feed-video-wrapper">
                                      <img
                                        className="content-tab-media mh-350"
                                        src={image.table_image}
                                        alt="post"
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <div className="feed-video-wrapper">
                              <img
                                className="feed-tab-media mh-350"
                                src={
                                  image.table_image
                                    ? image.table_image
                                    : "/assets/dummy_video.png"
                                }
                                alt="post"
                              />
                            </div>
                            // <img
                            //   className="feed-tab-media mh-350"
                            //   src={
                            //     image.table_image
                            //       ? image.table_image
                            //       : "/assets/dummy_video.png"
                            //   }
                            //   alt="post"
                            // />
                          )}
                        </>
                      )}
                      <p className="creator-feed-content mb-0 w-auto">
                        {image.platform && (
                          <span className="creator-feed-content-icon">
                            {renderPlatformIcon(image.platform)}
                          </span>
                        )}
                        {new Date(image.post_date).getFullYear() > 2000 && (
                          <span className="creator-feed-content-date">

                            {formatPostDate(image.post_date)}
                          </span>
                        )}
                      </p>
                    </div>

                    <div className="feed-tab-row-actions-mobile">
                      <ProductBankActionButtons
                        post={image}
                        postIndex={image.index}
                        postId={image.table_id}
                        pageIndex={image.pageIndex}
                        index={index}
                        type={"PRODUCT"}
                        url={image.table_image}
                        link={image.table_url}
                        data={image}
                        dataCount={data.length}
                        user_id={user_id}
                        refetchData={refetchData}
                        platform={image.platform}
                        refetchCount={refetchCount}
                        linkFilterRefetch={linkFilterRefetch}
                        setSelectedProductLnikFilter={
                          setSelectedProductLnikFilter
                        }
                        username={username}
                      />
                    </div>
                  </div>

                  <div className="feed-tab-row-tags">
                    <div className="search-container-tagInput">
                      <input
                        type="text"
                        id="tagInput"
                        enterKeyHint="enter"
                        placeholder="Enter tags here"
                        className="tagInput"
                        onKeyUp={(e: any) => {
                          if (e.keyCode === 13 && e.target.value.trim()) {
                            setTags((prev: any) => [
                              ...(prev || []),
                              e.target.value.trim(),
                            ]);
                            submitTag(
                              e,
                              image.table_tags,
                              e.target.value,
                              image.table_id,
                              1,
                              1
                            );
                          }
                          // setTags((prev:any) => [...(prev.split(",")  || []), e.target.value.trim()]);
                          // submitTag(
                          //   e,
                          //   image.table_tags,
                          //   e.target.value,
                          //   image.table_id,
                          //   1,
                          //   1
                          // );
                        }}
                      />
                    </div>
                    <div className="image-table-tags">
                      {image.table_tags ? (
                        <TagsBox
                          tagsArray={
                            image.table_tags
                              ? image.table_tags.split(",")
                              : [""]
                          }
                          removeTag={(tag: string) => {
                            removeTag(
                              image.table_tags
                                ? image.table_tags.split(",")
                                : [""],
                              tag,
                              image.table_id,
                              1,
                              index
                            );
                          }}
                          page="content"
                        />
                      ) : (
                        <p className="noTags">No Tags</p>
                      )}
                    </div>
                  </div>

                  <div className="feed-tab-actions">
                    <ProductBankActionButtons
                      post={image}
                      postIndex={image.index}
                      postId={image.table_id}
                      pageIndex={image.pageIndex}
                      index={index}
                      platform={image.platform}
                      type={"PRODUCT"}
                      url={image.table_image}
                      link={image.table_url}
                      data={image}
                      user_id={user_id}
                      refetchData={refetchData}
                      refetchCount={refetchCount}
                      linkFilterRefetch={linkFilterRefetch}
                      dataCount={data.length}
                      setSelectedProductLnikFilter={
                        setSelectedProductLnikFilter
                      }
                      username={username}
                    />
                  </div>
                </div>
              );
            })}
          </Fragment>
        ) : (
          <p className="">
            {filter && filter !== "" ? (
              <>
                <div className="empty-state-message">
                  <span className="empty-state-icon">🔍</span>
                  <p>No search results found.</p>
                </div>
              </>
            ) : (
              <>
                {activeKey === "archived" ? (
                  <i>No posts have been archived yet.</i>
                ) : activeKey === "active,ad" ? (
                  <i>No posts have been marked as an ad yet.</i>
                ) : activeKey === "active,featured" ? (
                  <i>No posts have been marked as featured yet.</i>
                ) : (
                  <div className="empty-state-message">
                    <span className="empty-state-icon">📦</span>
                    <p>No products added yet.</p>
                    <p>
                      Click the "Add Product" button to add your first product
                      to the bank.
                    </p>
                  </div>
                )}
              </>
            )}
          </p>
        )}
        {/* ))} */}
      </div>

      {/* Your Modal component */}
      <Modal
        title="Show Relevant Comments"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        style={{
          overflowY: "auto",
          maxHeight: "calc(100vh - 300px)",
        }}
        focusTriggerAfterClose={false}
        getContainer={false}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            // loading={loading}
            onClick={handleOk}
            loading={confirmLoading}
          >
            Save
          </Button>,
        ]}
      >
        {/* Your Modal content */}
      </Modal>

      {/* {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext> */}
      {/* <AddProductModal
        username={username}
        user_id={user_id}
        addProductModalShow={addProductModalShow}
        setAddProductModalShow={setAddProductModalShow}
        refetchData={refetchData}
        refetchCount={refetchCount}
        linkFilterRefetch={linkFilterRefetch}
     
      /> */}
      <ProductBankDeleteModal
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        post_id={selectedPostId}
        user_id={user_id}
        username={username}
        refetchData={refetchData}
        refetchCount={refetchCount}
        linkFilterRefetch={linkFilterRefetch}
        setSelectedProductLnikFilter={setSelectedProductLnikFilter}
        data={data}
        setLocalData={setLocalData}
      />
    </>
  );
};

export default ProductBankSearchTable;
